import { useQuery } from "react-query";
import * as wahaService from "services/wahaService";

export const useCheckWhatsapp = (options = {}) => {
  return useQuery({
    queryKey: ["checkWhatsapp"],
    queryFn: wahaService.checkWhatsapp,
    ...options,
  });
};